"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreatmentAssignmentVariantServiceResponse = void 0;
const common_1 = require("../utils/common");
class TreatmentAssignmentVariantServiceResponse {
  constructor(assignmentContext, dataVersion, configs, flights) {
    this.assignmentContext = assignmentContext;
    this.dataVersion = dataVersion;
    this.configs = configs;
    this.flights = flights;
    this.assignedVariants = this.getAssignedVariants();
    this.featureVariables = this.configs;
  }
  getAssignedVariants() {
    if (!this.flights) {
      return [];
    }
    let results = [];
    let flightAllocationPairs = this.parseAllocationId(this.assignmentContext);
    Object.keys(this.flights).forEach(key => {
      let value = String(this.flights[key]);
      let variant = {
        name: value,
        numberline: key,
        variantAllocationId: flightAllocationPairs.has(value) ? flightAllocationPairs.get(value) : -1
      };
      results.push(variant);
    });
    return results;
  }
  parseAllocationId(assignmentContext) {
    let flightAllocationMap = new Map();
    if (!assignmentContext) {
      return flightAllocationMap;
    }
    let parameterDelimeter = ";";
    let allocationDelimeter = ":";
    let flightAllocationsArray = assignmentContext.split(parameterDelimeter);
    for (let flightAllocationString of flightAllocationsArray) {
      if (!flightAllocationString)
        //check for null or undefined
        continue;
      let flightAllocationPair = flightAllocationString.split(allocationDelimeter);
      switch (flightAllocationPair.length) {
        case 1:
          flightAllocationMap.set(flightAllocationPair[0], -1);
          break;
        case 2:
          let x = common_1.isNumeric(flightAllocationPair[1]) ? Number(flightAllocationPair[1]) : -1;
          flightAllocationMap.set(flightAllocationPair[0], x);
          break;
        default:
          break;
      }
    }
    return flightAllocationMap;
  }
}
exports.TreatmentAssignmentVariantServiceResponse = TreatmentAssignmentVariantServiceResponse;